var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('BeeInput',{on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))]):_c('BeeInput',{staticClass:"spinner-container"},[_c('Spinner',{staticClass:"mini"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }